<template>
<div style="height: 100%;">
  <vxe-toolbar perfect v-if="toolbar" class="table-toolbar" :style="`height: ${toolbarHeight}px`">
    <template #buttons>
      <slot name="toolbar"></slot>
    </template>
  </vxe-toolbar>
  <div class="table-content" :style="`height: calc(100% - ${toolbar ? toolbarHeight : 0}px)`">
    <vxe-grid ref='xGrid' 
      height="auto"
      v-bind="$attrs"
      v-on="$listeners"
      :row-id="rowId"
      :scroll-y="{enabled: false}"
      :size="size"
      :border="border"
      :row-style="rowStyle"
      :columns="columns"
      :loading="loading"
      :resizable="resizable"
      :showOverflow="showOverflow"
      :data="data"
      :checkbox-config="{trigger: 'row', highlight: false}"
      :radio-config="{trigger: 'row', highlight: false}"
      :row-config="{isCurrent: true,useKey: true}"
      :merge-cells="mergeCells"
      @current-change="currentChange"
      @radio-change="radioChange"
      @checkbox-change="selectedChange"
      @checkbox-all="selectedChange"
    >
      <template #pager v-if="!hidePage">
        <vxe-pager
          :background="true"
          size="medium"
          align="left"
          :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Total']"
          :current-page="pagerConfig.pageNum || 1"
          :page-size="pagerConfig.pageSize || 50"
          :page-sizes="pagerConfig.pageSizes || [10, 20, 50, 100, 200]"
          :total="pagerConfig.total"
          @page-change="handlePageChange"
        >
          <template #right>
            <slot name="pagerRight"></slot>
          </template>
        </vxe-pager>
      </template>    
    </vxe-grid>
  </div>
</div>
</template>

<script>
export default {
  props: {
    rowId: {
      type: String,
      default(){
        return 'id'
      }
    },
    toolbar: {
      type: Boolean,
      default: false,
    },
    toolbarHeight: {
      type: Number,
      default: 45,
    },
    border: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'small',
    },
    resizable: {
      type: Boolean,
      default: false,
    },
    showOverflow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hidePage: {
      type: Boolean,
      default: false,
    },
    pagerConfig: {
      type: Object,
      default: () => ({
        pageNum: 1,
        pageSize: 50,
        pageSizes: [20, 50, 100, 200],
        total: 0,
      })
    },
    columns: {
      type: Array,
      default: () => ([]),
    },
    data: {
      type: Array,
      default: () => ([]),
    },
    rowStyle: { 
      type: Function
    },
    mergeCells: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      selectRow: null,
    }
  },
  watch: {
    pagerConfig(val) {
      console.log(val)
    }
  },
  mounted() {
    // 获取表格组件实例
    const tableRef = this.$refs.xGrid
    for (const key in tableRef) {
      // 将 vxe-grid 组件中的方法添加到当前封装的表格方法中
      // 让调用当前表格组件的父组件可以通过实例直接访问 vxe-grid 组件中的方法
      if (
        Object.hasOwnProperty.call(tableRef, key) && 
        typeof tableRef[key] === 'function' && 
        !Object.hasOwnProperty.call(this, key)
      ) {
        this[key] = tableRef[key]
      }
    }
  },
  methods: {
    handlePageChange (val) {
      this.$emit('pageChange', Object.assign({}, val, {pageNum: val.currentPage}))
    },

    radioChange({ row }) { 
      this.$emit('radioChange' , {
        selectedList: [row],
        currentItem: row
      });
    },

    currentChange({ row , rowIndex }) {
      Object.assign(row, {rowIndex})
      // this.$refs.xGrid.setRadioRow(row)
      // this.selectedChange({ records: [row] })
    },

    selectedChange({ records }) {
      this.$emit('selectedChange' , {
        selectedList: records,
        currentItem: records[records.length - 1] || {}
      })
    },
  }
}
</script>

<style lang="less">
.vxe-table--render-default .vxe-body--row.row--current {
  background: rgb(133, 215, 243);
}
</style>